/**
 * Grid-layout placement helpers shared by the report editor + renderer.
 *
 * `nextBlockPosition` decides where a freshly-added block lands on the
 * 12-column grid: blocks flow left-to-right three columns at a time,
 * wrapping to a new two-row band once a row is full. Used by the editor's
 * "add block" / "accept wizard proposal" paths and as the renderer's
 * fallback when a block has no persisted layout yet.
 */
export interface BlockGridPosition {
  x: number;
  y: number;
}

export function nextBlockPosition(existingCount: number): BlockGridPosition {
  return {
    x: (existingCount * 3) % 12,
    y: Math.floor((existingCount * 3) / 12) * 2,
  };
}
